import React, { FC, Fragment, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import { pandaEuStatusVar, pandaStatusVar } from 'apollo/reactive-variables/scan-case';
import { Alert, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import { pandaEuStatusTemplate } from 'apollo/templates/scanner-case';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import { ScannerCaseAuthStatus } from 'models/scanner-case';

const PandaEuAuthContainer: FC = () => {
    const { t: translate } = useTranslation(['scan-cases']);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [pandaEuAuthUrl, setPandaEuAuthUrl] = useState('');
    const pandaEuFrontendStatus = pandaEuStatusVar();
    const { showBoundary } = useDenthubErrorBoundary();
    const isCurrentlyAuthorizing = window.location.href.includes('panda-auth-callback');

    useQuery(pandaEuStatusTemplate, {
        onCompleted: ({ pandaEuStatus }: { pandaEuStatus: ScannerCaseAuthStatus }) => {
            pandaEuStatusVar(pandaEuStatus);
            if (pandaEuStatus.enabled && !pandaEuStatus.authorized && !isCurrentlyAuthorizing) {
                const randomValue = new Date().getTime();
                const pandaReturnUrl = `/eu/connect/authorize/callback?client_id=${pandaEuStatus.clientId}&response_type=code&scope=openid profile api.resource.full offline_access&redirect_uri=${CONSTANTS.PANDA_EU_AUTH_REDIRECT}&client_secret=${pandaEuStatus.clientSecret}&state=${randomValue}&nonce=${randomValue}&code_challenge=${pandaEuStatus.codeChallenge}&code_challenge_method=S256`;
                setPandaEuAuthUrl(
                    `${CONSTANTS.PANDA_AUTH_URL}/eu/Account/Login?ReturnUrl=${encodeURIComponent(pandaReturnUrl)}`,
                );
                setDialogOpen(true);
            }
        },
        onError(error) {
            showBoundary(error);
        },
    });

    const onDialogClose = () => {
        setDialogOpen(false);
    };

    return (
        <Fragment>
            {pandaEuFrontendStatus.enabled ? (
                <DHDialog
                    fullWidth
                    maxWidth="sm"
                    open={dialogOpen}
                    onClose={onDialogClose}
                    title={`${translate('scan-cases:YOU_NEED_TO_LOGIN_TO_PANDA')} (EU Region)`}
                >
                    <Alert severity="info" sx={{ whiteSpace: 'pre-wrap' }}>
                        {translate('scan-cases:PANDA_LOGIN_DESC')}
                    </Alert>
                    <Box mt={2} sx={{ textAlign: 'center' }}>
                        <Button variant="contained" href={pandaEuAuthUrl}>
                            {translate('scan-cases:LOGIN_TO_PANDA')} (EU Region)
                        </Button>
                    </Box>
                </DHDialog>
            ) : undefined}
        </Fragment>
    );
};

export default PandaEuAuthContainer;
